const toggleText = ( module, screenwidth = 1024 ) => {
	const BUTTON_LABEL = 'read more';

	if ( screenwidth && window.innerWidth > screenwidth ) {
		return;
	}

	const button = document.createElement( 'button' );
	button.textContent = BUTTON_LABEL;
	button.className = 'without-style';

	const paragraphs = module.querySelectorAll( '.toggle-text p' );
	const paragraphWithBtn = paragraphs[ 0 ].cloneNode( true );
	paragraphWithBtn.appendChild( button );

	const container = module.querySelector( '.toggle-text' );
	container.innerHTML = '';
	container.append( paragraphWithBtn );

	button.addEventListener( 'click', () => {
		container.innerHTML = '';
		if ( container.classList.contains( 'opened' ) ) {
			button.textContent = BUTTON_LABEL;
			paragraphWithBtn.appendChild( button );
			container.append( paragraphWithBtn );
			container.classList.remove( 'opened' );
		} else {
			button.textContent = 'hide';
			paragraphs[ paragraphs.length - 1 ].appendChild( button );
			paragraphs.forEach( ( item ) => {
				container.append( item );
			} );
			container.classList.add( 'opened' );
		}
	} );
};

export { toggleText };
